import React from "react";
import { NavLink } from "react-router-dom";
// import NavProfile from "./NavProfile";
import SideBarProfile from "./SideBarProfile";

const B2GSidebar = ({ sidebarbuttonData, setSidebarbuttonData, }) => {
    const SidebarButton = (e) => {
        sidebarbuttonData ? setSidebarbuttonData(false) : setSidebarbuttonData(true)
    }
    return (
        <>
            <nav id="sidebar" className="sidebarsidebar bg-left-navabr" >
                <ul className="navbar-nav scrollBar ms-auto mb-lg-0 d-flex pb-4 flex-column text-left mt-1">
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Dashboard"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"b2g/states"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"States"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/districts"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Districts"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/communities"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Community's"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/wards"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Wards"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/survey"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Survey"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/BWGSurvey"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"BWG Survey"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/driverLive"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Driver live"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/dailyreportDate"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Daily Report"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/CollectionWard"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Collection Ward"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/collections"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Collection"}
                            </span>
                        </li>
                    </NavLink>
                    {/* <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/complains"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Complain"}
                            </span>
                        </li>
                    </NavLink> */}
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/admin"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Admin"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/iecteam"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"IEC Team"}
                            </span>
                        </li>
                    </NavLink>
                    <NavLink className={({ isActive }) => isActive ? "active active-transition font-bold nav-link select2" : "font-thin nav-link select2 active"} to={"/b2g/cleaner"} onClick={SidebarButton}>
                        <li className="nav-item select  mb-1 ms-3">
                            <span className="sidebar_text">
                                <i className={`fa-solid `}></i> &nbsp; {"Cleaner"}
                            </span>
                        </li>
                    </NavLink>
                    <li className="nav-item select mt-3   ms-4 ml-1 ">
                        <div className="dropdown-toggle text-white ms-1" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <span className="sidebar_text">
                                {"Complain All"}
                            </span>
                        </div>
                        <ul className="dropdown-menu menu-side text-start p-1" aria-labelledby="dropdownMenuButton1">
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/complains"} onClick={SidebarButton}>
                                <li className="link-item">
                                    <span className="sidebar_text">
                                        <i className={`fa-solid `}></i> &nbsp; {"Complain"}
                                    </span>
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/ComplainAdminList"} onClick={SidebarButton}>
                                <li className="link-item">
                                    <span className="sidebar_text">
                                        <i className={`fa-solid `}></i> &nbsp; {"Complain Admin"}
                                    </span>
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/ComplainUserAppList"} onClick={SidebarButton}>
                                <li className="link-item">
                                    <span className="sidebar_text">
                                        <i className={`fa-solid `}></i> &nbsp; {"User App"}
                                    </span>
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/compainWeb"} onClick={SidebarButton}>
                                <li className="link-item">
                                    <span className="sidebar_text">
                                        <i className={`fa-solid `}></i> &nbsp; {"Complain Web"}
                                    </span>
                                </li>
                            </NavLink>
                        </ul>
                    </li>
                    <li className="nav-item select mt-3   ms-4 ml-1 ">
                        <div className="dropdown-toggle text-white ms-1" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <span className="sidebar_text">
                                {"Members"}
                            </span>
                        </div>
                        <ul className="dropdown-menu menu-side text-start p-1" aria-labelledby="dropdownMenuButton1">
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/CollectionDriver"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Driver"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/vehicle"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Vehicle"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/supervisorList"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Supervisor"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/CollectionIEC_Person"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"IEC-Person"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/HelperList"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Helper"}
                                </li>
                            </NavLink>


                        </ul>
                    </li>
                    <li className="nav-item select mt-3   ms-4 ml-1 ">
                        <div className="dropdown-toggle text-white ms-1" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <span className="sidebar_text">
                                {"Waste"}
                            </span>
                        </div>
                        <ul className="dropdown-menu menu-side text-start p-1" aria-labelledby="dropdownMenuButton1">
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/waste"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Waste"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/category"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Category"}
                                </li>
                            </NavLink>
                        </ul>
                    </li>
                    <li className="nav-item select mt-3   ms-4 ml-1 ">
                        <div className="dropdown-toggle text-white ms-1" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <span className="sidebar_text">
                                {"Event"}
                            </span>
                        </div>
                        <ul className="dropdown-menu menu-side text-start p-1" aria-labelledby="dropdownMenuButton1">
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/Event"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Event"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/Manager"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Manager"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"/b2g/Dustbin"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Dustbin"}
                                </li>
                            </NavLink>
                        </ul>
                    </li>
                    <li className="nav-item select mt-3   ms-4 ml-1 ">
                        <div className="dropdown-toggle text-white ms-1" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <span className="sidebar_text">
                                {"User App"}
                            </span>
                        </div>
                        <ul className="dropdown-menu menu-side text-start p-1" aria-labelledby="dropdownMenuButton1">
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"b2g/unit"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"Unit"}
                                </li>
                            </NavLink>
                            <NavLink className={({ isActive }) => isActive ? "active-transition font-bold dropdown-item" : "font-thin dropdown-item"} to={"b2g/wasteCategory"} onClick={SidebarButton}>
                                <li className=" link-item ">
                                    {"wasteCategory"}
                                </li>
                            </NavLink>

                        </ul>
                    </li>
                    <SideBarProfile />
                </ul>
            </nav>
        </>
    )
}

export default B2GSidebar;